import { Component } from '@angular/core';
import { DataLoaderService } from '../../../../services/data-loader.service';
@Component({
    selector: 'cancel-confirmation',
    templateUrl: './cancel-confirmation.template.html',
    styleUrls: ['./cancel-confirmation.component.css']
})

export class CancelComponent {
    private options: any;
    constructor(private dataLoaderService: DataLoaderService) {
    }

    ngOnInit() {
    }

    cancelConfiguration() {
        (<HTMLInputElement>document.getElementById('RETCODEID')).value = '0';
        (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
        (<HTMLFormElement>document.getElementById('form1')).submit();
    }
    

}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/cancel-confirmation/cancel-confirmation.component.ts